module.exports = "bW9kdWxlLmV4cG9ydHMgPSBfX3dlYnBhY2tfcHVibGljX3BhdGhfXyArICJzdGF0aWMvZm9udHMvR3JpZmZ5LVJlZ3VsYXIuZWI2NGU3MC50dGYiOw=="


//////////////////
// WEBPACK FOOTER
// ./node_modules/base64-loader!./node_modules/scratch-render-fonts/src/Griffy-Regular.ttf
// module id = WwRj
// module chunks = 0